import styles from "../../../styles/base/Admin.module.scss";
import { Tabs, Input, Button, Tooltip } from "@qastanfit/qastan-ui"
import { MainObject } from "../../../pages/admin/Translations";
import { useState, useRef, useEffect } from "react";

interface Props {
    onSave: (object:MainObject) => void;
    selectedPage: string;
    object: MainObject;
}

const EditPage : React.FC<Props> = ({onSave, selectedPage, object}) => {
    const [selectedLanguage, setselectedLanguage] = useState<"N" | "F" | "E" >("N");
    const [isDisabled, setisDisabled] = useState(true);
    const [show_addItem, setshow_addItem] = useState(true);

    const newObj = useRef<MainObject>()
    const labelRefAdd = useRef<HTMLInputElement>()

    const [label_additem, setlabel_additem] = useState("");
    const [value_additem, setvalue_additem] = useState("");

    const changeInput = (key:string, value:string) => {
        let o = {...object}
        o[selectedLanguage][selectedPage][key] = value
        setisDisabled(false);
        newObj.current = o;
    }

    const addItem = () => {
        let o = {...object}
        o.KEYS[selectedPage] = {[label_additem]:"", ...o.KEYS[selectedPage]}
        o.N[selectedPage] = {[label_additem]:value_additem, ...o.N[selectedPage]}
        o.F[selectedPage] = {[label_additem]:value_additem, ...o.F[selectedPage]}
        o.E[selectedPage] = {[label_additem]:value_additem, ...o.E[selectedPage]}
        newObj.current = o;
        onSave(newObj.current)
        setshow_addItem(false);
    }

    const deleteKey = (key:string) => {
        let o = {...object}
        delete o.KEYS[selectedPage][key]
        delete o.N[selectedPage][key]
        delete o.F[selectedPage][key]
        delete o.E[selectedPage][key]
        newObj.current = o;
        onSave(newObj.current)
    }

    useEffect(()=>{
        if(!show_addItem) setshow_addItem(true)
    }, [show_addItem])

    return (
        <div className={styles.detail}>
            <div className={styles.header}>
                <h1>Pagina: {selectedPage}</h1>
                <Button onClick={()=>{if(newObj.current){onSave(newObj.current); setisDisabled(true)}}} disabled={isDisabled}>Opslaan</Button>
            </div>

            <div className={styles.add_item}>
                <p className={styles.title}>Item toevoegen</p>
                {show_addItem && 
                <>
                    <Input onChange={(target:HTMLInputElement) => {setlabel_additem(target.value)}} placeholder="Label"/>
                    <Input onChange={(target:HTMLInputElement) => {setvalue_additem(target.value)}} placeholder="Value"/>
                </>
                }
                <Button onClick={()=>{addItem()}} disabled={label_additem === "" || value_additem === ""}>Opslaan</Button>
            </div>

            <Tabs onChange={(page:string)=>{setselectedLanguage(page.substring(0,1) as "N" | "F" | "E")}} options={["Nederlands", "Frans", "Engels"]} ease="back"/>
            <div className={styles.input_container}>
                {Object.keys(object[selectedLanguage][selectedPage]).map((key:string, index:number)=>{
                    return (
                        <div className={styles.input} key={index}>
                            <div className={styles.input_header}>
                                <p className={styles.label}>{key}</p>         
                                <Tooltip position="left" text="Verwijderen"><button onClick={()=>{deleteKey(key)}} className={styles.delete_button}><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg></button></Tooltip>
                            </div>
                            <Input onChange={(target:HTMLInputElement) => {changeInput(key, target.value)}} value={object[selectedLanguage][selectedPage][key]} placeholder={`${key}...`}/>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default EditPage;